<div class="card overflow-hidden" *ngIf="user">
  <div class="bg-soft bg-primary">
    <div class="row text-primary justify-content-end mt-4 mx-2">
      <div class="col-9">
        <div class="row">
          <form [formGroup]="profileForm">
            <div class="mb-2">
              <label for="displayName" class="form-label">Név</label>
              <input type="text" class="form-control" id="displayName" formControlName="displayName" placeholder="Név">
            </div>
              <div class="mb-2">
                <label for="inputGroupFile02" class="form-label">Profil kép</label>
                <div class="input-group">
                  <ng-container *ngIf="uploadProgress$ | async as uploadProgress">
                    <ngb-progressbar [value]="uploadProgress" height="3px"></ngb-progressbar>
                  </ng-container>
                  <input type="file" class="form-control-sm" id="inputGroupFile02" formControlName="avatar" (change)="fileSelected($event.target.files)">
                  <button class="btn btn-info btn-sm" type="button" id="inputGroupFileAddon04" (click)="uploadAvatar()">Feltölt</button>
                </div>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="row">
      <div class="col-sm-4">
        <div class="avatar-md profile-user-wid mb-4">
          <img [src]="user?.photoURL || 'assets/images/users/defaultAvatar.jpg'" alt="" class="img-thumbnail rounded-circle">
        </div>
        <h5 class="font-size-12 text-truncate">{{user.displayName || user.email}}</h5>
        <p *ngIf="user.displayName" class="text-muted mb-0 text-truncate">{{user.email}}</p>
      </div>

      <div class="col-sm-8">
        <div class="pt-2">
          <div class="row mb-1" *ngFor="let role of roles$ | async">
            <div class="col-8 text-truncate">
              <!-- <h5 class="font-size-15">$1245</h5> -->
              <p class="text-muted mb-0">{{role?.host?.name}}</p>
            </div>
            <div class="col-4">
              <!-- <h5 class="font-size-15">$1245</h5> -->
              <p class="mb-0">{{role?.role}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-end">
        <a href="javascript: void(0);" class="btn btn-primary mx-2" style="width: 100px;" (click)="saveUser()">Mentés <i
          class="mdi mdi-arrow-right ms-1"></i></a>
    </div>
    <div class="row">
      <pre>{{profileForm.value.avatar}}</pre>
    </div>
  </div>
</div>




  <!-- <ng-container *ngIf="{avatarFromFile: avatarFromFile$ | async} as observables">
    <button *ngIf="observables.avatarFromFile" mat-icon-button color="warn" (click)=deleteUserAvatar()><mat-icon>delete</mat-icon>Feltöltött profilkép törlése</button>
    <app-file-upload
      [user]="user"
      [onlyImage]="true"
      [label]="'Felhasználó fénykép'"
      [show]="!observables.avatarFromFile"
      [uploadPath]="avatarUploadPath"
      [showDescription]="false"
      (lastUploadedFile)="saveUserAvatar($event)">
    </app-file-upload>
    <mat-form-field appearance="legacy" *ngIf="!observables.avatarFromFile">
      <mat-label>Fénykép URL</mat-label>
      <input matInput placeholder="URL" formControlName="userPhoto">
    </mat-form-field>
  </ng-container>   -->

